module.exports = __webpack_public_path__ + "img/115.10.d2e1cbc9.png";